import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { toApiDate } from '@/utils/helpers'

export default function useCreateTransactionSeries() {
  const queryClient = useQueryClient()

  const action = async ({
    type,
    frequency,
    cron,
    date,
    vaultId,
    categoryId = undefined,
    fromVaultId = undefined,
    description = undefined,
    amount,
    modelId = undefined,
    is_skip_allocation,
    is_refund = false,
    behaviour = 'Standard',
    ends_after_count = undefined,
    ends_after_date = undefined,
  }) => {
    const response = await httpClient.post(`team/cash-flow/series`, {
      type,
      frequency,
      cron,
      next_transaction_date: date,
      vault_id: vaultId,
      transaction_category_id: categoryId,
      from_vault_id: fromVaultId,
      transaction_description: description,
      amount,
      what_if_id: modelId,
      is_skip_allocation,
      is_refund,
      behaviour,
      ends_after_count,
      ends_after_date: toApiDate(ends_after_date),
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (e) => {
      toast.error(e?.response?.data?.message ?? 'An error occurred.')
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transactions'] })
      queryClient.invalidateQueries({ queryKey: ['todo-count'] })
      queryClient.invalidateQueries({
        queryKey: ['transaction-repeat-options'],
      })
      queryClient.invalidateQueries({ queryKey: ['todo-count'] })
      queryClient.invalidateQueries({ queryKey: ['todos', 'list'] })
      queryClient.invalidateQueries({
        queryKey: ['models'],
      })

      toast.success('Transaction series successfully added.')
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
